var _rect, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastGamesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_26590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1003_26590",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 180
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "#FEF6FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1003_26590)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.5,
    cy: 140,
    rx: 72.5,
    ry: 30,
    fill: "#FEF6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1003_26590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6675 128.895H83.5525L83.7674 90.2243H44.6675V128.895ZM141.219 67.9655L118.466 45.2128C113.418 40.1775 105.217 40.1807 100.182 45.216L77.4293 67.9655C72.4318 72.9598 72.3186 80.8807 77.1775 85.9979C77.7816 86.6398 78.6315 87.0018 79.5126 87.0018H83.7674C85.5423 87.0018 86.9899 88.4463 86.9899 90.2243V94.4791C86.9899 95.335 87.3297 96.1533 87.9341 96.7574L100.182 109.002C102.7 111.52 106.01 112.782 109.321 112.782C112.632 112.782 115.942 111.52 118.466 109.002L141.219 86.2527C146.26 81.2113 146.26 73.007 141.219 67.9655V67.9655Z",
    fill: "url(#paint0_linear_1003_26590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7674 80.5567H44.6676C39.3177 80.5567 35 84.8747 35 90.2243V128.895C35 134.244 39.3177 138.562 44.6676 138.562H83.7674C89.1173 138.562 93.435 134.244 93.435 128.895V90.2243C93.435 84.8747 89.1173 80.5567 83.7674 80.5567ZM51.3274 125.672C49.5226 125.672 48.1049 124.254 48.1049 122.449C48.1049 120.645 49.5226 119.227 51.3274 119.227C53.1322 119.227 54.5499 120.645 54.5499 122.449C54.5499 124.254 53.1322 125.672 51.3274 125.672ZM51.3274 99.8918C49.5226 99.8918 48.1049 98.4742 48.1049 96.6693C48.1049 94.8645 49.5226 93.4468 51.3274 93.4468C53.1322 93.4468 54.5499 94.8645 54.5499 96.6693C54.5499 98.4742 53.1322 99.8918 51.3274 99.8918ZM64.2175 112.782C62.4127 112.782 60.995 111.364 60.995 109.559C60.995 107.755 62.4127 106.337 64.2175 106.337C66.0223 106.337 67.44 107.755 67.44 109.559C67.44 111.364 66.0223 112.782 64.2175 112.782ZM77.1076 125.672C75.3027 125.672 73.8851 124.254 73.8851 122.449C73.8851 120.645 75.3027 119.227 77.1076 119.227C78.9124 119.227 80.3301 120.645 80.3301 122.449C80.3301 124.254 78.9124 125.672 77.1076 125.672ZM77.1076 99.8918C75.3027 99.8918 73.8851 98.4742 73.8851 96.6693C73.8851 94.8645 75.3027 93.4468 77.1076 93.4468C78.9124 93.4468 80.3301 94.8645 80.3301 96.6693C80.3301 98.4742 78.9124 99.8918 77.1076 99.8918ZM107.04 93.0558C105.781 94.3143 105.781 96.3546 107.04 97.6131C108.298 98.8716 110.339 98.8716 111.597 97.6131C112.856 96.3546 112.856 94.3143 111.597 93.0558C110.339 91.7973 108.298 91.7973 107.04 93.0558ZM107.04 74.8265C105.781 76.085 105.781 78.1252 107.04 79.3837C108.298 80.6422 110.339 80.6422 111.597 79.3837C112.856 78.1252 112.856 76.085 111.597 74.8265C110.339 73.568 108.298 73.568 107.04 74.8265ZM111.597 61.1544C112.856 59.8959 112.856 57.8556 111.597 56.5971C110.339 55.3386 108.299 55.3386 107.04 56.5971C105.782 57.8556 105.782 59.8959 107.04 61.1544C108.299 62.4129 110.339 62.4129 111.597 61.1544Z",
    fill: "url(#paint1_linear_1003_26590)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_26590",
    x1: 53.2342,
    y1: 121.427,
    x2: 117.857,
    y2: 47.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1003_26590",
    x1: 73.7706,
    y1: 55.6532,
    x2: 73.7706,
    y2: 138.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_26590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1003_26590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(35 35)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastGamesIcon);
export default __webpack_public_path__ + "static/media/fast-games-icon.c716a249ab55c5c718e7c4c92659d387.svg";
export { ForwardRef as ReactComponent };